import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomDropdown, { DropdownOption } from './custom-dropdown.component';
import { SearchInput } from './search/search-input.components';

interface DeductionFiltersProps {
    selectedYear: string;
    selectedMonth: string;
    selectedClient: string;
    searchQuery: string;
    onYearChange: (value: string) => void;
    onMonthChange: (value: string) => void;
    onClientChange: (value: string) => void;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    clients?: DropdownOption[];
    loading?: boolean;
}

const DeductionFilters: React.FC<DeductionFiltersProps> = ({
    selectedYear,
    selectedMonth,
    selectedClient,
    searchQuery,
    onYearChange,
    onMonthChange,
    onClientChange,
    onSearchChange,
    clients = [],
    loading = false
}) => {
    const { t } = useTranslation();

    // Generate year options (from 1980 to current year)
    const currentYear = new Date().getFullYear();
    const yearCount = currentYear - 1980 + 1;
    const yearOptions: DropdownOption[] = [
        { value: 'all', label: t('ALL_YEARS') || 'All Years' },
        ...Array.from({ length: yearCount }, (_, i) => ({
            value: String(currentYear - i),
            label: String(currentYear - i)
        }))
    ];

    // Month options
    const monthOptions: DropdownOption[] = [
        { value: 'all', label: t('ALL_MONTHS') || 'All Months' },
        { value: '1', label: t('JANUARY') || 'January' },
        { value: '2', label: t('FEBRUARY') || 'February' },
        { value: '3', label: t('MARCH') || 'March' },
        { value: '4', label: t('APRIL') || 'April' },
        { value: '5', label: t('MAY') || 'May' },
        { value: '6', label: t('JUNE') || 'June' },
        { value: '7', label: t('JULY') || 'July' },
        { value: '8', label: t('AUGUST') || 'August' },
        { value: '9', label: t('SEPTEMBER') || 'September' },
        { value: '10', label: t('OCTOBER') || 'October' },
        { value: '11', label: t('NOVEMBER') || 'November' },
        { value: '12', label: t('DECEMBER') || 'December' }
    ];

    // Client options from API with "All Customers" option
    const clientOptions: DropdownOption[] = [
        { value: 'all', label: t('ALL_CUSTOMERS') || 'All Customers' },
        ...clients
    ];

    return (
        <div className="deduction-filters">
            <div className="deduction-filters__row">
                <div className="deduction-filters__dropdown">
                    <CustomDropdown
                        options={yearOptions}
                        value={selectedYear}
                        onSelect={onYearChange}
                        placeholder={t('SELECT_YEAR') || 'Select Year'}
                        className="deduction-year-dropdown"
                    />
                </div>
                
                <div className="deduction-filters__dropdown">
                    <CustomDropdown
                        options={monthOptions}
                        value={selectedMonth}
                        onSelect={onMonthChange}
                        placeholder={t('SELECT_MONTH') || 'Select Month'}
                        className="deduction-month-dropdown"
                    />
                </div>

                <div className="deduction-filters__dropdown">
                    <CustomDropdown
                        options={clientOptions}
                        value={selectedClient}
                        onSelect={onClientChange}
                        placeholder={t('SELECT_CUSTOMER') || 'Select Customer'}
                        className="deduction-client-dropdown"
                        disabled={loading}
                    />
                </div>

                <div className="deduction-filters__search">
                    <SearchInput
                        value={searchQuery}
                        onChange={onSearchChange}
                        placeholder={t('SEARCH_PLACEHOLDER') || 'Search here...'}
                        className="deduction-search"
                    />
                </div>
            </div>
        </div>
    );
};

export default DeductionFilters;
